import {
  apiPost,
  apiUrl,
  formatApiMessage,
  getAuthHeaders,
  notifySessionRevokedIfNeeded,
} from '../config/api'
import type { OfferDto } from '../types/offer'

export type GenerateOfferPayload = {
  raw_notes: string
  ai_instruction?: string
  current_text?: string
  customerId?: string
  amount?: number
}

export type GenerateOfferResponse = { generated_text: string }

export class OfferCreateHttpError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message)
    this.name = 'OfferCreateHttpError'
  }
}

export async function generateOfferText(
  payload: GenerateOfferPayload,
): Promise<GenerateOfferResponse> {
  const res = await fetch(apiUrl('/offers/generate'), {
    method: 'POST',
    headers: getAuthHeaders(true),
    body: JSON.stringify(payload),
  })
  const json = (await res.json().catch(() => ({}))) as {
    message?: unknown
    generated_text?: string
  }
  if (!res.ok) {
    if (res.status === 401) {
      notifySessionRevokedIfNeeded()
    }
    throw new OfferCreateHttpError(formatApiMessage(json), res.status)
  }
  if (!json.generated_text) {
    throw new Error('Άδεια απάντηση από τον διακομιστή.')
  }
  return { generated_text: json.generated_text }
}

export type CreateOfferPayload = {
  customerId: string
  raw_notes: string
  title?: string
  generated_text?: string
  amount?: number
}

export async function createOffer(
  payload: CreateOfferPayload,
): Promise<OfferDto> {
  return apiPost<OfferDto>('/offers', payload)
}
